/**
 * File: userSideNavigation.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.0.2
 * Created: 2026-04-19
 * Last Updated: 2026-06-22
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Local project files
import { routes } from "../../constants/routes";

// Icons
import { BiBuildings } from "react-icons/bi";
import { BsLayoutSidebar } from "react-icons/bs";
import { FaRegUserCircle } from "react-icons/fa";
import { HiOutlineDocumentAdd } from "react-icons/hi";
import { MdApps, MdOutlineSettings, MdOutlineSupport } from "react-icons/md";
import { MdOutlineReviews } from "react-icons/md";
import { RiDashboardLine } from "react-icons/ri";

// User Side Navigation
export const userSideNavigation = {
    id: "user-side-navigation",
    logo: {
        type: "icon",
    },
    sidebarItems: {
        header: {
            id: "user-side-navigation-link-0",
            type: "button",
            icon: BsLayoutSidebar,
            tooltip: "Toggle sidebar",
            iconSize: 20,
        },
        home: [
            {
                id: "user-side-navigation-link-1",
                type: "link",
                icon: RiDashboardLine,
                label: "Dashboard",
                tooltip: "Dashboard",
                linkHref: routes.user.dashboard.abs,
            },
            {
                id: "user-side-navigation-link-2",
                type: "link",
                icon: BiBuildings,
                label: "Projects",
                tooltip: "Projects",
                linkHref: routes.user.dashboard.abs,
            },
            {
                id: "user-side-navigation-link-3",
                type: "link",
                icon: MdOutlineReviews,
                label: "Reviews",
                tooltip: "Reviews",
                linkHref: routes.user.dashboard.abs,
            },
            {
                id: "user-side-navigation-link-4",
                type: "link",
                icon: HiOutlineDocumentAdd,
                label: "Orders",
                tooltip: "Orders",
                linkHref: routes.user.orders.abs,
            },
        ],
        support: [
            {
                id: "user-side-navigation-link-2",
                type: "button",
                icon: MdApps,
                label: "Apps",
                tooltip: "Apps",
            },
            {
                id: "user-side-navigation-link-5",
                type: "button",
                icon: MdOutlineSettings,
                label: "Settings",
                tooltip: "Settings",
            },
            {
                id: "user-side-navigation-link-6",
                type: "button",
                icon: MdOutlineSupport,
                label: "Support",
                tooltip: "Support",
            },
        ],
    },
    userCard: {
        icon: FaRegUserCircle,
        name: "User",
        text: "Free",
    },
};
